export const SYNOPSIS_LENGTH = 377;
export const SYNOPSIS_VISIBLE_LENGTH = 369;
export const LOGO_HEIGHT = 40;
export const COMPONENT_NAME = 'VideoDetails';
